import React, { useEffect, useState } from 'react';
import { ProjectSchema, useProjectsList } from './useProjectsList';
import { PageContentFlex, PageMainColumn, PageTitle, PageTitleLine, PageWrapper } from '../Common/PageComponents';
import { Buttons, FormGrid, LoadingIndicator, OccupyFreeSpace, PseudoLink2, SimpleDialog, useWindowHotkey } from '../../toolympus/components/primitives';
import { FormControlsForFields } from '../../toolympus/components/schemed';
import { IconButton, styled } from '@mui/material';
import { useProjectsSettings } from './useProjectsSettings';
import { Add } from '@mui/icons-material';
import { ProjectsList } from './ProjectsList';
import { ThemeSettings } from '../../theme';
import { StatusIcon } from './ProjectStatus';
import { Task } from '../Tasks/typings';
import { useAppActions } from '../../AppActionsProvider';
import { ProjectTagsActivator } from './ProjectTagsPicker';
import { useBrowserStoredValue } from '../../toolympus/hooks/useBrowserStoredValue';

interface Props {
  
}

const TitleLinks = styled(Buttons)`
  font-size: ${ThemeSettings.typography.fontSizes.smaller};
`;


export const ProjectsListPage = (props: Props) => {
  const data = useProjectsList();
  useWindowHotkey("alt+n", () => {
    data.newProject.startEditing({ title: "" });
  });

  const { fields } = useProjectsSettings();

  const [showTasks, setShowTasks] = useState<boolean>(true);

  const tab = useBrowserStoredValue("current", "tab", undefined);

  useEffect(() => {
    if(tab.value === "later") {
      data.laterProjects.requestLoad();
    }
    if(tab.value === "finished") {
      data.finishedProjects.requestLoad();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab.value]);

  const actions = useAppActions();
  useEffect(() => {
    const onTaskChanged = (task: Task) => {
      if(data.currentTasks.data[task.project_id]) {
        const found = data.currentTasks.data[task.project_id].find(x => x._id === task._id);
        if(found) {
          data.currentTasks.setData(x => ({
            ...x,
            [task.project_id]: data.currentTasks.data[task.project_id].map(t => t._id === task._id ? { ...t, ...task } : t),
          }));
        }
      }
    }
    actions.registerTaskUpdatedHandler(onTaskChanged);
    return () => actions.unregisterTaskUpdatedHandler(onTaskChanged);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageWrapper>
      <PageTitleLine dontGrowTitle>
        <PageTitle>
        Проекты: {tab.value === "current" ? "текущие" : ""}{tab.value === "later" ? "отложенные" : ""}{tab.value === "finished" ? "завершенные" : ""}
        </PageTitle>
        <TitleLinks>
          {tab.value !== "current" && <PseudoLink2 onClick={() => tab.update("current")}>{StatusIcon.current} текущие</PseudoLink2>}
          {tab.value !== "later" && <PseudoLink2 onClick={() => tab.update("later")}>{StatusIcon.later} отложенные</PseudoLink2>}
          {tab.value !== "finished" && <PseudoLink2 onClick={() => tab.update("finished")}>{StatusIcon.finished} завершенные</PseudoLink2>}
        </TitleLinks>


        <OccupyFreeSpace />
        {data.list.isLoading && <LoadingIndicator />}
        <IconButton size="small" color="primary" onClick={() => data.newProject.startEditing({ title: "" })}>
          <Add />
        </IconButton>
      </PageTitleLine>
      <PageContentFlex>
        <ProjectTagsActivator tags={data.tags} update={v => data.setTags(v || [])} />
        <PageMainColumn extraBottomPadding>
          {tab.value === "current" &&
            <ProjectsList
              data={data.list}
              editAttributes={data.editAttributes}
              fields={fields}
              currentTasks={data.currentTasks}
              reorderProjectBefore={data.reorderProjectBefore}
              setShowTasks={setShowTasks}
              showTasks={showTasks}
              />}

          {tab.value === "later" &&
            <ProjectsList
              data={data.laterProjects}
              editAttributes={data.editAttributes}
              fields={fields}
              reorderProjectBefore={data.reorderProjectBefore}
              />}

          {tab.value === "finished" &&
            <ProjectsList
              data={data.finishedProjects}
              editAttributes={data.editAttributes}
              fields={fields}
              />}
          
        </PageMainColumn>
      </PageContentFlex>

      <SimpleDialog
        dialogTitle="Создать проект"
        saveLabel="создать"
        noFullscreen
        save={() => data.newProject.save()}
        isOpen={data.newProject.isEditing}
        close={data.newProject.cancel}
        >
          <FormGrid columns="1fr">
            <FormControlsForFields
              fields={[
                ["title", { controlProps: { autoFocus: true } }]
              ]}
              schema={ProjectSchema}
              data={data.newProject.item}
              onChange={(o,c) => data.newProject.update(c)}
              />
          </FormGrid>
      </SimpleDialog>
    </PageWrapper>
  );
}
